import { UserFull } from '@wellesley/openapi'
import {
  useGetApiV1UsersByUserIdFollowingQuery,
  useGetApiV1UsersFolloweesQuery,
  isHiddenListError,
} from '@wellesley/user'
import { FollowStatus } from 'types'
import { authSlice } from '@wellesley/auth'
import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'

type HookProps = {
  skip?: boolean
  userId?: string
  status?: FollowStatus
}

const useFollowee = ({ status, userId, skip = false }: HookProps) => {
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)
  const canFetchMyFollowees = !!status && isLogged

  const [isHidden, setIsHidden] = useState(false)

  const {
    data: myFollowees,
    isLoading: isMyFolloweesLoading,
    error: myFolloweesError,
  } = useGetApiV1UsersFolloweesQuery(
    { status },
    { skip: !canFetchMyFollowees || skip || isHidden },
  )

  const {
    data: userFollowees,
    isLoading: isUserFoloweesLoading,
    error: userFolloweesError,
  } = useGetApiV1UsersByUserIdFollowingQuery(
    { userId: userId! },
    { skip: canFetchMyFollowees || !userId || !isLogged || skip || isHidden },
  )

  const data = myFollowees || (userFollowees as UserFull[])
  const isLoading = isMyFolloweesLoading || isUserFoloweesLoading

  useEffect(() => {
    if (
      isHiddenListError(myFolloweesError) ||
      isHiddenListError(userFolloweesError)
    ) {
      setIsHidden(true)
    }
  }, [myFolloweesError, userFolloweesError])

  return { data, isLoading, isHidden }
}

export default useFollowee
